<template>
  <div
    class="d-flex justify-sm-center"
    :class="{ 'justify-space-around': !left, 'justify-lg-end': left }"
  >
    <span v-if="text" class="result-text">{{ text }}</span>
    <div v-if="single" class="result-digit single">
			{{ value }}
    </div>
    <div
      v-else
      class="result-digit"
      v-for="(digit, index) in value"
      :key="index"
    >
			{{ digit }}
    </div>
  </div>
</template>

<script>
import chunk from "lodash/chunk.js";
import fiery0 from "../../../../assets/img/quicklotto/0.png";
import fiery1 from "../../../../assets/img/quicklotto/1.png";
import fiery2 from "../../../../assets/img/quicklotto/2.png";
import fiery3 from "../../../../assets/img/quicklotto/3.png";
import fiery4 from "../../../../assets/img/quicklotto/4.png";
import fiery5 from "../../../../assets/img/quicklotto/5.png";
import fiery6 from "../../../../assets/img/quicklotto/6.png";
import fiery7 from "../../../../assets/img/quicklotto/7.png";
import fiery8 from "../../../../assets/img/quicklotto/8.png";
import fiery9 from "../../../../assets/img/quicklotto/9.png";

export default {
  name: "ResultDigitDisplay",
  props: {
    single: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    group: {
      type: Number,
      default: null
    },
    text: {
      type: String,
      default: ""
    },
    ballSize: {
      type: String,
      default: "30px"
    },
    left: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fieryBalls: [
        fiery0,
        fiery1,
        fiery2,
        fiery3,
        fiery4,
        fiery5,
        fiery6,
        fiery7,
        fiery8,
        fiery9
      ]
    };
  },
  methods: {
    chunk
  },
  computed: {
    computedValue() {
      if (this.group) {
        return chunk(this.value.split(""), this.group);
      } else {
        return this.value;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "css/variables";

.result-digit {
  display: flex;
	margin: 0 2px;
	border-radius: 50%;
	background-color: rgba($font-color-3, 0.9);
	border: 2px solid $font-color-3;
	color: white;
	font-size: 23px;
	height: 40px;
	width: 40px;
	justify-content: center;
	align-items: center;
}

.result-text {
  color: $font-color-3;
  font-size: 30px;
  margin-right: 5px;
  width: 60px;
  margin-bottom: 30px;
}
</style>
